import React, { useEffect } from 'react'
import { useState, useRef } from "react"
import { Modal, Breadcrumb, DatePicker, Button, Row, Col, Popover, Spin, Typography, Card, Steps, Select, Divider, message } from "antd"
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  PhoneOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons"
import dayjs from "dayjs"
import { getShifts } from '../../services/doctor/shift schedule/shift_schedule'
import Title from 'antd/es/skeleton/Title'
import PropTypes from 'prop-types'
import { updateAppointment } from '../../services/receptionist/book appointment/bookappointment'
import { useMessageApi } from '../../services/message api/MessageProvider'

const { Text } = Typography;
const { Step } = Steps;
const { Option } = Select;

const RescheduleAppointment = ({ visible, onCancel, doctors,appointment }) => {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [stats, setStats] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [selectedSlotDetails, setSelectedSlotDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState("search");
  const [selectedDoctor, setSelectedDoctor] = useState(doctors || null);
  const [showIndex, setShowIndex] = useState(null);
  const targetRefs = useRef([]);
  const messageApi = useMessageApi();



  console.log("appointment", appointment);

  const fetchShifts = async () => {
    
    try {
      const result = await getShifts(doctors?.id,selectedDate.format("YYYY-MM-DD"));
      if (result.success) {
        console.log("Fetched Data:", result?.data);
        const formData=result?.data;

        setStats(formData);
      } else {
        console.error("Error:", result.error || "Failed to fetch shifts");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };


  const formatTime = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const period = hrs >= 12 ? "PM" : "AM";
    const displayHours = hrs % 12 === 0 ? 12 : hrs % 12;
    return `${displayHours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")} ${period}`;
  };

  const getShiftLabel = (startTime) => {
    if (startTime < 360 || startTime >= 1200) return "Night"; // 8 PM to 6 AM
    if (startTime >= 720 && startTime < 1200) return "Evening"; // 12 PM to 8 PM
    return "Morning"; // Before 12 PM
  };
  const isPastSlot = (slotTime) => {
    const today = dayjs().startOf('day');
    const selected = dayjs(selectedDate).startOf('day');
  
    if (selected.isSame(today, 'day')) {
      const currentTimeInMinutes = dayjs().hour() * 60 + dayjs().minute();
      const slotTimeInMinutes =
        dayjs(slotTime, "hh:mm A").hour() * 60 +
        dayjs(slotTime, "hh:mm A").minute();
  
      return slotTimeInMinutes < currentTimeInMinutes;
    }
  
    // If date is not today, we assume it's not a past slot
    return false;
  };
  

//for doctor list


  console.log("Selected Doctor:", doctors);

  // Filter the doctors list based on the current filter.

  const handlePrev = () => {
    const today = dayjs().startOf('day'); 
    const previousDate = selectedDate.subtract(1, 'day');
  
    if (previousDate.isBefore(today)) {
      return;
    }
  
    setSelectedDate(previousDate);
  };

  const handleNext = () => {
    setSelectedDate(prev => prev.add(1, 'day'));
  };
  const customFormat = (value) => {
    return dayjs().isSame(value, 'day') ? 'Today, '+value.format('YYYY') : value.format('D MMM YYYY');
  };

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: 'topRight', // <-- key part for right side
  });
  const handleSubmit = async (slot) => {
    console.log("Selected Slot Details:", selectedSlotDetails);
    console.log("appointment", appointment);

      
        try {
          const appointmentData = {
            id: appointment?.id,
            shift_id: slot?.shift_id,
            doctor_id: appointment?.doctor_id,
            patient_id: appointment?.patient?.id,
            status:"Queue",
            reason_for_appointment: appointment?.reason_for_appointment,  
            slot_number:slot?.slot_number,
            appointment_date:selectedDate.format("YYYY-MM-DD"),
            appointment_time: slot.slot_start_time,
            _method: "put",
          };
          const result = await updateAppointment(appointmentData); 
          if (result?.success) {
            messageApi.open({
              type: 'success',
              content: 'Appointment Reschedule successfully!',
            });
            onCancel(false)


          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              const messageArray = Array.isArray(messages)
                ? messages
                : [messages];

              Array.isArray(messageArray)
                ? messageArray.forEach((msg) => {
                    messageApi.open({
                      type: "error",
                      content: `${field}: ${msg}`,
                      style: {
                        maxWidth: "300px",
                        minWidth: "300px",
                        textAlign: "left",
                        wordBreak: "break-word",
                        marginLeft: "auto",
                        marginRight: "0",
                      },
                    });
                  })
                : messageArray &&
                  messageApi.open({
                    type: "error",
                    content: `${field}: ${messageArray}`,
                    style: {
                      maxWidth: "300px",
                      minWidth: "300px",
                      textAlign: "left",
                      wordBreak: "break-word",
                      marginLeft: "auto",
                      marginRight: "0",
                    },
                  });
            });
            
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error?.message);
          // Show error to user
        }
  };  
 
  useEffect(() => {
    if (doctors) {
      fetchShifts();
    }
  }, [selectedDate, selectedDoctor]);

  const handleSlotClick = (slot, shiftId) => {
    if (!isPastSlot(slot.slot_start_time)) {
      setSelectedSlot(slot.slot_number)
      setSelectedSlotDetails({ ...slot, shift_id: shiftId })
      handleSubmit({...slot, shift_id: shiftId});
    }
  }
  const PopoverContent = ({ slot }) => {(
    <div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <div
            style={{
              width: 30,
              height: 30,
              backgroundColor: "#f0f0f0",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 8,
            }}
          >
            <UserOutlined />
          </div>
          <Text strong>{slot.bookedByName}</Text>
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
          <PhoneOutlined style={{ marginRight: 8 }} />
          <Text>{slot.bookedByPhone}</Text>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
          <ClockCircleOutlined style={{ marginRight: 8 }} />
          <Text>{slot.time}</Text>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
          <FileTextOutlined style={{ marginRight: 8 }} />
          <Text>{slot.type}</Text>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Button type="primary" ghost size="small" style={{ flex: 1 }}>
          Reschedule
        </Button>
        <Button danger ghost size="small" style={{ flex: 1 }}>
          Cancel
        </Button>
      </div>
    </div>
  )}

const handelecancel = () => {
    onCancel(false)
}




  return (
    <>
      <Modal
        title="Reschedule Appointment"
        visible={visible}
        maskClosable={false} 
        keyboard={false}
        onCancel={handelecancel}
        footer={null}
        width="80%"
        style={{ top: 30 }}
        bodyStyle={{ padding: 0, height: "85vh", overflow: "hidden" }}
      >
        <div
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          {/* Page Header */}
          <div
            style={{ padding: "16px 24px", borderBottom: "1px solid #f0f0f0" }}
          >
            <Row justify="center" align="middle">
              <Col span={8}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Button
                    type="text"
                    icon={<DoubleLeftOutlined />}
                    onClick={handlePrev}
                    style={{ fontSize: "16px" }}
                  />
                  <DatePicker
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date || dayjs())}
                    format={customFormat}
                    allowClear={false}
                    style={{ width: "auto" }}
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                  />
                  <Button
                    type="text"
                    icon={<DoubleRightOutlined />}
                    onClick={handleNext}
                    style={{ fontSize: "16px" }}
                  />
                </div>
              </Col>
            </Row>
          </div>

          {/* Content */}
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
              <Row style={{ width: "100%", height: "100%" }}>
                {/* Doctor Selection Sidebar */}

                {/* Appointment Slots */}
                <Col
                  style={{
                    height: "100%",
                    overflow: "auto",
                    padding: 16,
                  }}
                >
                  {stats?.map((shift, shiftIndex) => (
                    <div key={shiftIndex} style={{ marginBottom: 24 }}>
                      <div
                        style={{
                          display: "flex",
                          // centers horizontally
                          // centers vertically if there's height
                          marginBottom: 2,
                        }}
                      >
                        <h4>
                          {shift?.name} ({shift?.start_time} to{" "}
                          {shift?.end_time})
                        </h4>
                      </div>

                      <Row gutter={[8, 8]}>
                        {shift.time_slots.map((slot, index) => (
                          <Col
                            key={index}
                            xs={12} // 2 buttons per row on extra-small screens
                            sm={8} // 3 per row on small screens
                            md={6} // 4 per row on medium screens
                            lg={4} // 6 per row on large screens
                            xl={3} // 8 per row on extra-large screens
                          >
                            <Popover
                              content={
                                slot.isBooked ? (
                                  <PopoverContent slot={slot} />
                                ) : null
                              }
                              title={null}
                              trigger="hover"
                              open={
                                slot.isBooked &&
                                showIndex === `${shiftIndex}-${index}`
                              }
                              onOpenChange={(visible) => {
                                if (slot.isBooked) {
                                  setShowIndex(
                                    visible ? `${shiftIndex}-${index}` : null
                                  );
                                }
                              }}
                            >
                              <Button
                                style={{
                                  width: "100%",
                                  height: 40,
                                  opacity: isPastSlot(slot.slot_start_time)
                                    ? 0.6
                                    : 1,
                                  cursor: isPastSlot(slot.slot_start_time)
                                    ? "not-allowed"
                                    : "pointer",
                                  backgroundColor: slot?.booked
                                    ? "#bef7a1"
                                    : isPastSlot(slot.slot_start_time)
                                    ? "lightgrey"
                                    : "white",
                                  borderColor: slot.booked
                                    ? "#1890ff"
                                    : "#d9d9d9",
                                  boxShadow: isPastSlot(slot.slot_start_time)
                                    ? "none"
                                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  color: slot.booked ? "#2e37a4" : "black",
                                  borderRadius: 8,
                                }}
                                onClick={() => handleSlotClick(slot, shift.id)}
                                disabled={
                                  isPastSlot(slot.slot_start_time) ||
                                  slot.booked
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 13,
                                      height: 13,
                                      borderRadius: "50%",
                                      marginRight: 4,
                                      backgroundColor: slot.isBooked
                                        ? "#52c41a"
                                        : "transparent",
                                      border: slot.isBooked
                                        ? "none"
                                        : "1px solid #000000",
                                    }}
                                  />
                                  <span>{slot?.slot_start_time}</span>
                                </div>
                              </Button>
                            </Popover>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ))}
                </Col>
              </Row>
            </div>
          )}
        </div>
      </Modal>

      {/* Appointment Booking Steps Modal */}
    </>
  );
}

export default RescheduleAppointment

RescheduleAppointment.propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    doctors: PropTypes.object.isRequired,
    appointment: PropTypes.object.isRequired,

  };